// extracted by mini-css-extract-plugin
module.exports = {"banner":"NotificationBanner-module__banner___1ON2I"};